import { useMemo } from 'react';

import { usePageContext } from '@hooks/usePageContext';

import { Image } from './Image';
import { Typography } from './Typography';

type Props = {
  article: Article;
  showReadingTime?: boolean;
};

export const Author: React.FC<Props> = ({
  article,
  showReadingTime = false,
}) => {
  const { author, updatedAt, last_updated_at, content } = article;
  const { locale } = usePageContext();

  const readingTimeText = useMemo(() => {
    if (locale === 'fr') return 'min de lecture';
    if (locale === 'en') return 'min read';
  }, [locale]);

  return (
    <div className="flex flex-row items-center gap-3">
      <div className="h-[3rem] w-[3rem]">
        <Image src={author?.picture} className="rounded-full" />
      </div>
      <div className="text-sm">
        <Typography variant="body1" className="font-semibold">
          {author?.name}
        </Typography>
        <Typography variant="body1" className="text-gray-500">
          {/* {new Date(last_updated_at || updatedAt).toLocaleDateString('fr', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })} */}
          {showReadingTime && content && (
            <>
              {/* {' • '} */}
              {Math.round(
                content.data.childMarkdownRemark.html.length / 600,
              )}{' '}
              {readingTimeText}
            </>
          )}
        </Typography>
      </div>
    </div>
  );
};
